const Pricing = require("./containers/Pricing");

// Sync route definition
module.exports = [
    {
        path: "/buycredits",
        component: Pricing,
        exact: true
    },
    {
        path: "/pricing",
        component: Pricing,
        exact: true
    }
];



// WEBPACK FOOTER //
// ./src/routes/pricing/index.js